@if (model(); as item) {
  <section class="in-line-control">
    <header class="in-line-control-header">
      <div class="in-line-control-header-title">
        <span class="in-line-control-header-title-text" appLongTextTooltip>
          {{ item.ruleName || 'In-Line Control' }}
        </span>

        <div class="in-line-control-header-secondary-title">
          <span>{{
            (isTaintAnalysis() ? 'aiInLineControlPage.runtimeControl' : 'aiInLineControlPage.inLineFinding')
              | labelsProvider
          }}</span>
          <div class="separator">|</div>
          <app-status-label [statusLabel]="statusLabel()" />

          <div class="separator">|</div>
          <div class="in-line-control-header-secondary-title-property">
            {{ (item.timestamp | date: 'MMM d, y, HH:mm:ss') || 'N/A' }}
          </div>

          <div class="separator">|</div>
          <div class="in-line-control-header-secondary-title-property">
            <div>{{ 'aiInLineControlPage.idTitle' | labelsProvider }}</div>
            <app-copy-button
              class="copy-button"
              [value]="item.id || ''"
              [title]="item.id || ''"
              [isSecondaryFontColor]="true"
            >
            </app-copy-button>
          </div>
        </div>
      </div>

      <app-sidepanel-tabs class="in-line-control-header-tabs" [tabs]="tabs" (tabOnSelection)="onTabSelect($event)">
      </app-sidepanel-tabs>
    </header>

    <div class="in-line-control-body">
      <div class="in-line-control-body-tab" *ngIf="activeTabIndex === 0">
        <div class="in-line-control-body-tab-card summary-card">
          <div class="in-line-control-body-tab-card-title">
            {{ 'aiInLineControlPage.summaryCardTitle' | labelsProvider }}
          </div>
          <div>
            {{ item.ruleSummary || ('aiInLineControlPage.summaryDescription' | labelsProvider) }}
          </div>
          <app-card-fields [cardFields]="summaryCardFields()"></app-card-fields>

          @if (!isTaintAnalysis()) {
            <app-anchor-link
              [navigation]="{
                commands: ['app/ai-in-line-control'],
                queryParams: { q: 'inLineThreadId:' + item.threadId },
                queryParamsHandling: 'merge',
              }"
              (clicked)="onViewRelatedFindingsClick()"
            >
              <span appLongTextTooltip>{{ 'aiFindingPage.viewRelatedFindings' | labelsProvider }}</span>
            </app-anchor-link>
          }
        </div>

        @if (isTaintAnalysis()) {
          @if (item.taintAnalysisEvidence && item.taintAnalysisEvidence.length > 0) {
            <div class="in-line-control-body-tab-card evidence-card">
              <app-taint-analysis-evidence [evidence]="item.taintAnalysisEvidence"></app-taint-analysis-evidence>
            </div>
          } @else {
            <div class="in-line-control-body-tab-card evidence-card">
              <div class="in-line-control-body-tab-card-title">
                {{ 'aiInLineControlPage.evidenceTitle' | labelsProvider }}
              </div>
              <div>{{ 'aiInLineControlPage.evidenceNoData' | labelsProvider }}</div>
            </div>
          }
        }

        @if (!isTaintAnalysis()) {
          @if (item.findingsEvidence && item.findingsEvidence.length > 0) {
            <div class="finding-body-tab-card evidence-card">
              <div class="finding-body-tab-card-title">Evidence</div>
              @for (evidence of item.findingsEvidence; track evidence) {
                <div class="fields">
                  <div class="field-container">
                    <div class="field-key">Found in</div>
                    <div class="field-value-container">
                      @if (hasStepId(evidence)) {
                        <a
                          class="field-link-value__text step-link"
                          appLongTextTooltip
                          (click)="onStepLinkClick(evidence)"
                        >
                          {{ getStepType(evidence) | beautifyDisplayString }}
                        </a>
                      } @else {
                        <span appLongTextTooltip class="field-link-value__text">
                          {{ getStepType(evidence) | beautifyDisplayString }}
                        </span>
                      }
                      {{ getLocation(evidence) }}
                    </div>
                  </div>
                  @if (canShowEvidenceContent(evidence)) {
                    <div class="field-container">
                      <div class="field-key">Core Evidence</div>
                      <div class="field-value-container">
                        <div class="field-value-transcript">
                          <app-get-sensitive-data-input-action
                            [sensitiveDataMethod]="getSensitiveDataMethod(evidence)"
                            [showPopupBtn]="true"
                            [content]="''"
                            [sensitiveDataIndexes]="'0'"
                          >
                          </app-get-sensitive-data-input-action>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="in-line-control-body-tab-card actor-card">
            <div class="in-line-control-body-tab-card-title">Actor Details</div>
            <app-card-fields [cardFields]="actorCardFields()"></app-card-fields>
          </div>
        }
      </div>
    </div>
  </section>
} @else if (isLoading()) {
  <div class="loading-message">
    <p>Loading...</p>
  </div>
} @else {
  <div class="no-data-message">
    <p>No in-line control data available</p>
  </div>
}
